// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-edit-dialog__section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.profile__edit-form {
  width: 100%;
}

.profile-edit-dialog__section h4 {
  margin: 0;
}

.profile-edit-dialog__section fieldset {
  width: 100%;
  margin: 0;
  display: grid;
  gap: var(--spacing-sm);
  border: 0;
  padding: 0;
  min-inline-size: 0;
}
.profile-edit-dialog__field-description {
  color: var(--gray-600, #4A5565);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-normal, normal);
  line-height: var(--line-height-base, 1.5); /* 21px */
}

.profile-edit-dialog__bio-field-container {
  display: flex;
  width: 100%;
  max-width: 34rem;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xs, 0.75rem);
  box-sizing: border-box;
  margin: 0;
}

.profile-edit-dialog__row {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  max-width: 34rem;
}

.profile-edit-dialog__section--resume fieldset {
  gap: var(--spacing-xs, 0.75rem);
}

.profile-edit-dialog__row--language {
  margin-left: calc(-1 * var(--spacing-xs, 0.75rem));
}

.profile-edit-dialog__row--social {
  margin-left: calc(-1 * var(--spacing-2xs, 0.625rem));
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__field--social-type {
  flex: 0 0 7rem;
  width: 7rem;
  max-width: 7rem;
}

.profile-edit-dialog__field--social-url {
  flex: 1 1 auto;
  min-width: 0;
}

.profile-edit-dialog__row--full {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__row--project {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__row--resume-entry-header {
  align-items: center;
  border-bottom: 1px solid var(--gray-400, #99A1AF);
}

.profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__entry-heading {
  margin: 0;
}

.profile-edit-dialog__entry-heading {
  margin: 0;
  color: var(--gray-700, #364153);
  font-size: var(--font-size-sm, 0.875rem);
  font-style: normal;
  font-weight: var(--font-weight-md, 500);
  line-height: normal;
}

.educationEditSection .profile-edit-dialog__section-heading {
  margin: 0;
  color: var(--gray-700, #364153);
  font-size: 16px;
  font-weight: 500;
}

.profile-edit-dialog__row--resume-entry-header .profile-edit-dialog__delete-button,
#profile-modal .modal .profile-edit-dialog__row--resume-entry-header button.profile-edit-dialog__delete-button {
  min-height: 1.75rem;
  min-width: 1.75rem;
}

/* Force two direct children to split the row into equal columns. */
.profile-edit-dialog__row--equal > .profile-edit-dialog__field,
.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog__image-preview {
  display: grid;
  gap: var(--spacing-xs);
}

.profile-edit-dialog__image-preview-label,
.profile-edit-dialog__image-preview-description {
  margin: 0;
}

.profile-edit-dialog__image-preview-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.profile-edit-dialog__image-frame {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.profile-edit-dialog__image-camera-button {
  display: none;
  position: absolute;
  right: var(--spacing-2xs, 0.625rem);
  bottom: var(--spacing-2xs, 0.625rem);
  z-index: 1;
}

/* Override modal-wide button defaults for the small camera overlay control. */
#profile-modal .modal button.profile-edit-dialog__image-camera-button {
  display: none !important;
  position: absolute;
  right: var(--spacing-2xs, 0.625rem);
  bottom: var(--spacing-2xs, 0.625rem);
  width: 1.25rem;
  height: 1.25rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
  padding: 3px;
  background: var(--white, #FFF);
  border-radius: 3.333px;
  box-shadow: 0 0 4.444px 0 rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
}

.profile-edit-dialog__image-camera-button svg {
  width: 0.875rem !important;
  height: 0.875rem !important;
  display: block;
  flex-shrink: 0;
}
.profile-edit-dialog__image-camera-capture-row {
  display: flex;
  justify-content: center;
  width: 100%;
}

.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-row {
  margin-bottom: calc(var(--spacing-lg, 1.25rem) / -2);
}

.profile-edit-dialog__image-camera-capture-frame {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: calc(var(--spacing-xs, 0.625rem) / 2);
  margin-bottom: var(--spacing-xs, 0.625rem);
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid var(--gray-200, #E5E7EB);
  border-radius: 8px;
}

.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-frame {
  margin-top: calc(var(--spacing-xs, 0.625rem) / 4);
  margin-bottom: calc(var(--spacing-xs, 0.625rem) / 2);
}

.profile-edit-dialog__image-camera-capture-frame[hidden] {
  display: none;
}

.profile-edit-dialog__image-camera-capture-frame table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

.profile-edit-dialog__image-camera-capture-frame td {
  text-align: center;
  vertical-align: middle;
}

.profile-edit-dialog__image-camera-capture-frame tr:last-child {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-2xs, 0.625rem);
}

.profile-edit-dialog__image-camera-capture-frame tr:last-child td {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: auto;
}

.profile-edit-dialog__image-camera-capture-frame tr:last-child td:first-child {
  margin-right: auto;
}

#profile-modal .modal .profile-edit-dialog__image-camera-capture-frame tr:last-child td:first-child button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.profile-edit-dialog__camera-control {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-edit-dialog__camera-control-actions {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: var(--spacing-2xs, 0.625rem);
  width: max-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: calc(var(--spacing-2xs, 0.625rem) / 2);
  align-self: center;
}

.profile-edit-dialog__camera-control-cancel {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: var(--gray-600, #4A5565) !important;
  margin-right: 0 !important;
}

.profile-edit-dialog__camera-control-cancel svg {
  display: block;
}

#profile-modal .modal .profile-edit-dialog__camera-control-cancel:hover,
#profile-modal .modal .profile-edit-dialog__camera-control-cancel:focus-visible {
  background: transparent !important;
  border: 0 !important;
  color: var(--gray-900, #101828) !important;
}
/*   display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  padding: 0.25rem 0.625rem;
  border: 1px solid var(--gray-300, #D5D7DA) !important;
  -- background: var(--gray-200, #E5E7EB) !important; 
  background: var(--gray-100, #FFF) !important;
  color: var(--gray-700, #364153) !important;
  box-shadow: none !important;
  border-radius: 0.375rem;
  font-weight: var(--font-weight-md, 500); */
.profile-edit-dialog__camera-control-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: var(--font-size-xxs, 0.75rem) !important; /* 12 px */
  font-weight: var(--font-weight-xbold, 700) !important;
  line-height: var(--line-height-base, 1.5) !important; /* 150% */
  border-radius: var(--border-radius-base, 0.3125rem) !important;
  border: 0.8px solid var(--gray-300, #D1D5DC) !important;
  color: var(--gray-900, #101828) !important;
  background: var(--white, #FFF) !important;
  padding: 6.6px 11.075px 7px 12.8px !important;
}

#profile-modal .modal .profile-edit-dialog__camera-control-actions button:hover,
#profile-modal .modal .profile-edit-dialog__camera-control-actions button:focus-visible {
  background: var(--gray-100, #F3F4F6) !important;
  border-color: var(--gray-400, #99A1AF) !important;
}

.profile-edit-dialog__image-camera-capture-frame video,
.profile-edit-dialog__image-camera-capture-frame canvas {
  display: block;
  width: 100%;
  max-width: 260px;
  height: auto;
  border-radius: 0.5rem;
  margin: 0 auto;
}

#profile-modal .modal .profile-edit-dialog__image-camera-capture-frame button {
  font-size: var(--font-size-sm, 0.875rem);
}

.profile-edit-dialog__image-upload-button,
.profile-edit-dialog__image-remove-button {
  min-height: var(--min-touch-target, 44px);
  padding: 0 var(--spacing-sm);
}

.profile-edit-dialog__field,
.profile-edit-dialog__field-type {
  display: block;
  margin: 0;
}

.profile-edit-dialog__field-type {
  width: 100%;
}

.profile-edit-dialog__field {
  /* flex: 1 1 auto; */
  min-width: 0;
}

.profile__edit-form--resume .profile-edit-dialog__field,
.profile__edit-form--resume .profile-edit-dialog__field-type:not(.hidden),
.profile__edit-form--contact-info .profile-edit-dialog__field,
.profile__edit-form--contact-info .profile-edit-dialog__field-type:not(.hidden) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xxs, 0.3125rem);
  flex: 1 0 0;
}

.profile__edit-form--resume .profile-edit-dialog__row {
  max-width: 100%;
  width: 100%;
}

.profile__edit-form--resume .profile-edit-dialog__section fieldset > .profile-edit-dialog__field {
  max-width: 100%;
}

.profile__edit-form--resume .profile-edit-dialog__field > input,
.profile__edit-form--resume .profile-edit-dialog__field > select,
.profile__edit-form--resume .profile-edit-dialog__field > textarea,
.profile__edit-form--resume .profile-edit-dialog__field-type > input,
.profile__edit-form--resume .profile-edit-dialog__field-type > select,
.profile__edit-form--resume .profile-edit-dialog__field-type > textarea,
.profile__edit-form--contact-info .profile-edit-dialog__field > input,
.profile__edit-form--contact-info .profile-edit-dialog__field > select,
.profile__edit-form--contact-info .profile-edit-dialog__field > textarea,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > input,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > select,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > textarea {
  align-self: stretch;
}

.profile-edit-dialog__field--resume-location {
  flex: 1 0 0;
  width: auto;
  max-width: none;
}

.profile-edit-dialog__row--resume-dates {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__field--date-group {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog__date-pair {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  width: 100%;
}

.profile-edit-dialog__date-pair > select {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog__field--stack {
  display: grid;
  gap: var(--spacing-xxs);
}

.profile-edit-dialog__field--stack > small {
  display: block;
  width: 100%;
  text-align: right;
}

.profile-edit-dialog__bio-field-container > small {
  align-self: flex-end;
  text-align: right;
}

.profile-edit-dialog__field--full {
  max-width: 100% !important;
  width: 100%;
}

.profile-edit-dialog__field--row-width {
  max-width: 34rem;
  width: 100%;
}

.profile-edit-dialog--heading .profile-edit-dialog__row,
.profile-edit-dialog--heading .profile-edit-dialog__field--row-width {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {
  padding-bottom: calc(var(--spacing-sm, 0.938rem) / 2);
  margin-bottom: calc(var(--spacing-sm, 0.938rem) / 2);
  border-bottom: 1px solid var(--slate-200, #E2E8F0);
}

.profile-edit-dialog--heading .profile-edit {
  gap: calc(var(--spacing-lg, 1.25rem) / 2);
}

.profile-edit-dialog__login-message {
  margin: 0;
  font-size: var(--font-size-xs, 0.75rem);
  color: var(--red-600, #E7000B);
}

.profile-edit-dialog__section + .profile-edit-dialog__login-message {
  margin-top: var(--spacing-sm, 0.938rem);
}

.profile__edit-form--projects .profile-edit-dialog__login-message {
  margin-top: var(--spacing-sm, 0.938rem);
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {
  max-width: 100%;
  width: 100%;
  gap: var(--spacing-2xs, 0.625rem);
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {
  display: block;
  width: 100%;
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {
  flex: 0 0 6.4375rem;
  width: 6.4375rem;
  min-width: 6.4375rem;
  max-width: 6.4375rem;
}

.profile-edit-dialog__field-type--contact-point select {
  width: auto;
  max-width: none;
  min-width: 6.4375rem;
}

.profile-edit-dialog__row--address-header {
  max-width: 34rem;
  align-items: flex-end;
}

.profile-edit-dialog__row--inline-end {
  justify-content: flex-end;
  max-width: 100%;
}

.profile-edit-dialog__checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  margin-left: auto;
  cursor: pointer;
}

.profile-edit-dialog__checkbox-input {
  width: 1rem;
  height: 1rem;
  margin: 0;
  flex: 0 0 auto;
  accent-color: var(--color-primary, #7C4DFF);
  cursor: pointer;
}

.profile-edit-dialog__checkbox-input:focus-visible {
  outline: var(--focus-indicator-width, 2px) solid var(--color-primary, #7C4DFF);
  outline-offset: 2px;
}

.profile-edit-dialog__checkbox-input:disabled {
  opacity: var(--opacity-disabled, 0.5);
}

/* The street-address row is a standalone label, so cap its width like the flex rows. */
.profile-edit-dialog__section fieldset > .profile-edit-dialog__field {
  max-width: 34rem;
}

.profile-edit-dialog__field-type--wide {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.profile-edit-dialog__field-type--contact-point {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  align-self: flex-start;
}

.profile-edit-dialog__actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.profile-edit-dialog__actions--edge {
  margin-left: auto;
}

.profile-edit-dialog__input-wrap {
  position: relative;
  width: 100%;
}

.profile-edit-dialog__input--with-action {
  width: 100%;
  box-sizing: border-box;
  padding-right: 7.5rem;
}

.profile-edit-dialog__input--with-leading-icon {
  width: 100%;
  box-sizing: border-box;
  padding-left: 2.1rem;
}

.profile-edit-dialog__search-icon {
  position: absolute;
  left: var(--spacing-2xs, 0.625rem);
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-400, #99A1AF);
  pointer-events: none;
  z-index: 1;
}

.profile-edit-dialog__search-icon svg {
  display: block;
  width: 0.8125rem;
  height: 0.8125rem;
}

.profile-edit-dialog__delete-button {
  min-height: var(--min-touch-target, 44px);
  min-width: var(--min-touch-target, 44px);
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

#profile-modal .modal button.profile-edit-dialog__delete-button {
  min-height: var(--min-touch-target, 44px);
  min-width: var(--min-touch-target, 44px);
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: inherit;
  box-shadow: none;
}

.profile-edit-dialog__delete-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  fill: currentColor;
}

.profile-edit-dialog__delete-icon svg {
  width: 1.1rem;
  height: 1.1rem;
}

.profile-edit-dialog__delete-button:hover,
.profile-edit-dialog__delete-button:focus-visible {
  color: var(--color-danger, #b42318);
}

.profile-edit-dialog__image-button {
  text-align: center;
  font-size: var(--font-size-xxs, 0.75rem); /* 12 px */
  font-weight: var(--font-weight-xbold, 700);
  line-height: var(--line-height-base, 1.5); /* 150% */
  border-radius: var(--border-radius-base, 0.3125rem);
  border: 0.8px solid var(--gray-300, #D1D5DC);
}

.profile-edit-dialog__image-upload-button {
  color: var(--gray-900, #101828);
  border: 0.8px solid var(--gray-300, #D1D5DC);
  background: var(--white, #FFF);
  padding: 6.6px 11.075px 7px 12.8px;
}

.profile-edit-dialog__image-remove-button {
  color: var(--red-600, #E7000B);
  padding: 6.6px 13.037px 7px 13.8px;
  border: 0.8px solid rgba(0, 0, 0, 0.00);
  background: var(--gray-100, #F3F4F6);
}

#profile-modal .modal .profile-edit-dialog__image-upload-button:hover,
#profile-modal .modal .profile-edit-dialog__image-upload-button:focus-visible,
#profile-modal .modal .profile-edit-dialog__image-remove-button:hover,
#profile-modal .modal .profile-edit-dialog__image-remove-button:focus-visible {
  background: var(--gray-100, #F3F4F6) !important;
  border-color: var(--gray-400, #99A1AF) !important;
}

/* Placeholder class for project paste action styling. */
.profile-edit-dialog__paste-button {
  display: flex;
  padding: 0.25rem 0.375rem; /* 4px 6px */
  align-items: center;
  position: absolute;
  background: var(--white, #fff);
  border: 0;
  outline: none;
  white-space: nowrap;
  right: var(--spacing-2xs, 0.625rem);
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  color: var(--gray-500, #6A7282);
  font-size: 0.75rem; /* 12px */
  font-weight: var(--font-weight-normal, 400);
}

.profile-edit-dialog__paste-button:focus,
.profile-edit-dialog__paste-button:focus-visible {
  outline: none;
}

/* remove the regular button styling for paste */
#profile-modal .modal button.profile-edit-dialog__paste-button,
#profile-modal .modal button.profile-edit-dialog__paste-button:hover,
#profile-modal .modal button.profile-edit-dialog__paste-button:focus,
#profile-modal .modal button.profile-edit-dialog__paste-button:focus-visible,
#profile-modal .modal button.profile-edit-dialog__paste-button:active {
  border: 0;
  outline: none;
  box-shadow: none;
  -webkit-appearance: none;
  appearance: none;
}
.profile-edit-dialog__paste-icon {
  width: 0.694rem; /* 11.105px */
  height: 0.813rem; /* 13.038px */
  fill: var(--gray-500, #6A7282);
}
#profile-modal .modal button.profile-edit-dialog__drag-handle {
  min-height: 1.75rem;
  min-width: 1.75rem;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.profile-edit-dialog__row--drop-target {
  outline: 1px dashed var(--gray-400, #99A1AF);
  outline-offset: 2px;
}

#profile-modal .modal button.profile-edit-dialog__delete-button:hover,
#profile-modal .modal button.profile-edit-dialog__delete-button:focus-visible {
  border: 0;
  background: transparent;
  color: var(--color-danger, #b42318);
}

.profile-edit-dialog__field input,
.profile-edit-dialog__field select,
.profile-edit-dialog__field-type input,
.profile-edit-dialog__field-type select {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
  border-radius: var(--border-radius-base, 0.3125rem);
  border: 1px solid var(--gray-400, #99A1AF);
  background: var(--white, #FFF);
  color: var(--gray-900, #101828);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  padding: var(--spacing-2xs, 0.625rem);
}

.profile-edit-dialog__field input.profile-edit-dialog__input--with-leading-icon {
  padding-left: 2.1rem;
}

/* Keep phone/email contact-point type selects compact. */
.profile-edit-dialog__field-type--contact-point > select {
  display: inline-block;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
}

/* In heading edit, force both type selects to fill the same fixed wrapper width. */
.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point > select {
  display: block;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

/* Keep phone/email type selects compact after the generic full-width rule above. */
.profile-edit-dialog__field-type--contact-point select {
  width: fit-content;
  max-width: none;
  min-width: 6.4375rem;
}

.profile-edit-dialog__textarea {
  color: var(--gray-900, #101828);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-md, 500);
  line-height: var(--line-height-loose, 1.6); /* 22.4px */
  border-radius: var(--border-radius-base, 0.3125rem);
  border: var(--border-width-sm, 0.1rem) solid var(--gray-400, #99A1AF);
  background: var(--white, #FFF);
}

.profile-edit-dialog__field textarea,
.profile-edit-dialog__field-type textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
}

/* Dedicated hook for the social account type select in SocialEditDialog. */
.profile-edit-dialog__social-account-select {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
  border-radius: var(--border-radius-base, 0.3125rem);
  border: 1px solid var(--gray-400, #99A1AF);
  background: var(--white, #FFF);
  color: var(--gray-900, #101828);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  padding: var(--spacing-2xs, 0.625rem);


}

.profile-edit-dialog__bio-field-container textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
}

.profile-edit-dialog__textarea {
  min-height: 10rem !important;
  height: auto;
  resize: vertical;
}

.profile-edit-dialog__field--stack small {
  justify-self: end;
  text-align: right;
}

@media (max-width: 640px) {
  .profile-edit-dialog__row {
    max-width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .profile-edit-dialog__row--equal > .profile-edit-dialog__field,
  .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {
    flex: 1 1 auto;
  }

  .profile-edit-dialog__field-type {
    flex: 1 1 auto;
  }

  .profile-edit-dialog__field-type--contact-point {
    flex: 1 1 auto;
    max-width: 100%;
  }

  .profile-edit-dialog__row--address-header {
    flex-direction: row;
    align-items: flex-end;
  }

  .profile-edit-dialog__row--social {
    margin-left: 0;
    gap: var(--spacing-2xs, 0.625rem);
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
  }

  .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .profile-edit-dialog__field--social-type {
    flex: 0 0 5.5rem;
    width: 5.5rem;
    max-width: 5.5rem;
  }

  .profile-edit-dialog__field--social-url {
    flex: 1 1 auto;
    min-width: 0;
  }

  .profile-edit-dialog__field--resume-location {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog__row--language {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
  }

  .profile-edit-dialog__row--language > .profile-edit-dialog__field {
    flex: 1 1 0;
    min-width: 0;
  }

  .profile-edit-dialog__row--resume-entry-header {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {
    margin-left: auto;
  }

  .profile-edit-dialog__row--skill {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-2xs, 0.625rem);
  }

  .profile-edit-dialog__row--skill > .profile-edit-dialog__field {
    flex: 1 1 0;
    min-width: 0;
  }

  .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {
    flex: 0 0 auto;
    margin-left: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-xs, 0.75rem);
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {
    margin-bottom: 0;
    flex: 0 0 auto;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,
  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
    width: 5.5rem;
    height: 5.5rem;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {
    display: inline-flex;
    right: var(--spacing-xxs, 0.3125rem);
    bottom: var(--spacing-xxs, 0.3125rem);
    width: 1.875rem;
    min-width: 1.875rem;
    min-height: 1.875rem;
  }

  #profile-modal .modal button.profile-edit-dialog__image-camera-button {
    display: inline-flex !important;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {
    flex: 1 1 auto;
    min-width: 0;
    gap: var(--spacing-xxs, 0.3125rem);
    width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {
    font-size: var(--font-size-sm, 0.875rem);
    line-height: var(--line-height-tight, 1.25);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {
    font-size: 10px;
    line-height: var(--line-height-base, 1.4);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {
    flex-wrap: nowrap;
    gap: var(--spacing-xs, 0.5rem);
    width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {
    flex: 1 1 0;
    width: 100%;
    padding: 0 0.75rem;
  }

  .profile-edit-dialog__row--inline-end {
    justify-content: flex-start;
  }

  .profile-edit-dialog__actions {
    justify-content: flex-start;
  }

  .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {
    justify-content: flex-end;
  }

  .profile-edit-dialog__textarea {
    min-height: 15rem !important;
  }

  .profile-edit-dialog__input-help-text {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/EditDialogs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,wCAAwC,EAAE,SAAS;EACnD,8CAA8C;EAC9C,yCAAyC,EAAE,SAAS;AACtD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oDAAoD;EACpD,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;EACxC,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;EACpC,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;;;;;;;;;;;4CAW4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD,EAAE,UAAU;EAC/D,qDAAqD;EACrD,oDAAoD,EAAE,SAAS;EAC/D,8DAA8D;EAC9D,uDAAuD;EACvD,0CAA0C;EAC1C,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;;EAEE,+CAA+C;EAC/C,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,oDAAoD;EACpD,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,8EAA8E;EAC9E,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uFAAuF;AACvF;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC,EAAE,UAAU;EACpD,0CAA0C;EAC1C,yCAAyC,EAAE,SAAS;EACpD,mDAAmD;EACnD,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;;;;EAIE,+CAA+C;EAC/C,iDAAiD;AACnD;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,yBAAyB,EAAE,YAAY;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,+BAA+B;EAC/B,kBAAkB,EAAE,SAAS;EAC7B,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;AACf;;AAEA,gDAAgD;AAChD;;;;;EAKE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe,EAAE,aAAa;EAC9B,gBAAgB,EAAE,aAAa;EAC/B,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;;;EAIE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,qCAAqC;EACrC,mDAAmD;EACnD,0CAA0C;EAC1C,8BAA8B;EAC9B,+BAA+B;EAC/B,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,mFAAmF;AACnF;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,uCAAuC;EACvC,0CAA0C,EAAE,WAAW;EACvD,mDAAmD;EACnD,qEAAqE;EACrE,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,qCAAqC;EACrC,mDAAmD;EACnD,0CAA0C;EAC1C,8BAA8B;EAC9B,+BAA+B;EAC/B,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;;;AAGvC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,oCAAoC;IACpC,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,WAAW;EACb;;EAEA;IACE,wCAAwC;IACxC,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".profile-edit-dialog__section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.profile__edit-form {\n  width: 100%;\n}\n\n.profile-edit-dialog__section h4 {\n  margin: 0;\n}\n\n.profile-edit-dialog__section fieldset {\n  width: 100%;\n  margin: 0;\n  display: grid;\n  gap: var(--spacing-sm);\n  border: 0;\n  padding: 0;\n  min-inline-size: 0;\n}\n.profile-edit-dialog__field-description {\n  color: var(--gray-600, #4A5565);\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\n  font-weight: var(--font-weight-normal, normal);\n  line-height: var(--line-height-base, 1.5); /* 21px */\n}\n\n.profile-edit-dialog__bio-field-container {\n  display: flex;\n  width: 100%;\n  max-width: 34rem;\n  padding: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-xs, 0.75rem);\n  box-sizing: border-box;\n  margin: 0;\n}\n\n.profile-edit-dialog__row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm);\n  max-width: 34rem;\n}\n\n.profile-edit-dialog__section--resume fieldset {\n  gap: var(--spacing-xs, 0.75rem);\n}\n\n.profile-edit-dialog__row--language {\n  margin-left: calc(-1 * var(--spacing-xs, 0.75rem));\n}\n\n.profile-edit-dialog__row--social {\n  margin-left: calc(-1 * var(--spacing-2xs, 0.625rem));\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__field--social-type {\n  flex: 0 0 7rem;\n  width: 7rem;\n  max-width: 7rem;\n}\n\n.profile-edit-dialog__field--social-url {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.profile-edit-dialog__row--full {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__row--project {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__row--resume-entry-header {\n  align-items: center;\n  border-bottom: 1px solid var(--gray-400, #99A1AF);\n}\n\n.profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__entry-heading {\n  margin: 0;\n}\n\n.profile-edit-dialog__entry-heading {\n  margin: 0;\n  color: var(--gray-700, #364153);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-style: normal;\n  font-weight: var(--font-weight-md, 500);\n  line-height: normal;\n}\n\n.educationEditSection .profile-edit-dialog__section-heading {\n  margin: 0;\n  color: var(--gray-700, #364153);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.profile-edit-dialog__row--resume-entry-header .profile-edit-dialog__delete-button,\n#profile-modal .modal .profile-edit-dialog__row--resume-entry-header button.profile-edit-dialog__delete-button {\n  min-height: 1.75rem;\n  min-width: 1.75rem;\n}\n\n/* Force two direct children to split the row into equal columns. */\n.profile-edit-dialog__row--equal > .profile-edit-dialog__field,\n.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog__image-preview {\n  display: grid;\n  gap: var(--spacing-xs);\n}\n\n.profile-edit-dialog__image-preview-label,\n.profile-edit-dialog__image-preview-description {\n  margin: 0;\n}\n\n.profile-edit-dialog__image-preview-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.profile-edit-dialog__image-frame {\n  position: relative;\n  display: inline-block;\n  line-height: 0;\n}\n\n.profile-edit-dialog__image-camera-button {\n  display: none;\n  position: absolute;\n  right: var(--spacing-2xs, 0.625rem);\n  bottom: var(--spacing-2xs, 0.625rem);\n  z-index: 1;\n}\n\n/* Override modal-wide button defaults for the small camera overlay control. */\n#profile-modal .modal button.profile-edit-dialog__image-camera-button {\n  display: none !important;\n  position: absolute;\n  right: var(--spacing-2xs, 0.625rem);\n  bottom: var(--spacing-2xs, 0.625rem);\n  width: 1.25rem;\n  height: 1.25rem;\n  min-width: 1.25rem;\n  min-height: 1.25rem;\n  padding: 3px;\n  background: var(--white, #FFF);\n  border-radius: 3.333px;\n  box-shadow: 0 0 4.444px 0 rgba(0, 0, 0, 0.25);\n  flex-shrink: 0;\n}\n\n.profile-edit-dialog__image-camera-button svg {\n  width: 0.875rem !important;\n  height: 0.875rem !important;\n  display: block;\n  flex-shrink: 0;\n}\n.profile-edit-dialog__image-camera-capture-row {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-row {\n  margin-bottom: calc(var(--spacing-lg, 1.25rem) / -2);\n}\n\n.profile-edit-dialog__image-camera-capture-frame {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: fit-content;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: calc(var(--spacing-xs, 0.625rem) / 2);\n  margin-bottom: var(--spacing-xs, 0.625rem);\n  padding: 10px;\n  box-sizing: border-box;\n  border: 1px solid var(--gray-200, #E5E7EB);\n  border-radius: 8px;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-frame {\n  margin-top: calc(var(--spacing-xs, 0.625rem) / 4);\n  margin-bottom: calc(var(--spacing-xs, 0.625rem) / 2);\n}\n\n.profile-edit-dialog__image-camera-capture-frame[hidden] {\n  display: none;\n}\n\n.profile-edit-dialog__image-camera-capture-frame table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.profile-edit-dialog__image-camera-capture-frame td {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.profile-edit-dialog__image-camera-capture-frame tr:last-child {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.profile-edit-dialog__image-camera-capture-frame tr:last-child td {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.profile-edit-dialog__image-camera-capture-frame tr:last-child td:first-child {\n  margin-right: auto;\n}\n\n#profile-modal .modal .profile-edit-dialog__image-camera-capture-frame tr:last-child td:first-child button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-edit-dialog__camera-control {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.profile-edit-dialog__camera-control-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center !important;\n  gap: var(--spacing-2xs, 0.625rem);\n  width: max-content;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: calc(var(--spacing-2xs, 0.625rem) / 2);\n  align-self: center;\n}\n\n.profile-edit-dialog__camera-control-cancel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  color: var(--gray-600, #4A5565) !important;\n  margin-right: 0 !important;\n}\n\n.profile-edit-dialog__camera-control-cancel svg {\n  display: block;\n}\n\n#profile-modal .modal .profile-edit-dialog__camera-control-cancel:hover,\n#profile-modal .modal .profile-edit-dialog__camera-control-cancel:focus-visible {\n  background: transparent !important;\n  border: 0 !important;\n  color: var(--gray-900, #101828) !important;\n}\n/*   display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2rem;\n  padding: 0.25rem 0.625rem;\n  border: 1px solid var(--gray-300, #D5D7DA) !important;\n  -- background: var(--gray-200, #E5E7EB) !important; \n  background: var(--gray-100, #FFF) !important;\n  color: var(--gray-700, #364153) !important;\n  box-shadow: none !important;\n  border-radius: 0.375rem;\n  font-weight: var(--font-weight-md, 500); */\n.profile-edit-dialog__camera-control-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: var(--font-size-xxs, 0.75rem) !important; /* 12 px */\n  font-weight: var(--font-weight-xbold, 700) !important;\n  line-height: var(--line-height-base, 1.5) !important; /* 150% */\n  border-radius: var(--border-radius-base, 0.3125rem) !important;\n  border: 0.8px solid var(--gray-300, #D1D5DC) !important;\n  color: var(--gray-900, #101828) !important;\n  background: var(--white, #FFF) !important;\n  padding: 6.6px 11.075px 7px 12.8px !important;\n}\n\n#profile-modal .modal .profile-edit-dialog__camera-control-actions button:hover,\n#profile-modal .modal .profile-edit-dialog__camera-control-actions button:focus-visible {\n  background: var(--gray-100, #F3F4F6) !important;\n  border-color: var(--gray-400, #99A1AF) !important;\n}\n\n.profile-edit-dialog__image-camera-capture-frame video,\n.profile-edit-dialog__image-camera-capture-frame canvas {\n  display: block;\n  width: 100%;\n  max-width: 260px;\n  height: auto;\n  border-radius: 0.5rem;\n  margin: 0 auto;\n}\n\n#profile-modal .modal .profile-edit-dialog__image-camera-capture-frame button {\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\n.profile-edit-dialog__image-upload-button,\n.profile-edit-dialog__image-remove-button {\n  min-height: var(--min-touch-target, 44px);\n  padding: 0 var(--spacing-sm);\n}\n\n.profile-edit-dialog__field,\n.profile-edit-dialog__field-type {\n  display: block;\n  margin: 0;\n}\n\n.profile-edit-dialog__field-type {\n  width: 100%;\n}\n\n.profile-edit-dialog__field {\n  /* flex: 1 1 auto; */\n  min-width: 0;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__field,\n.profile__edit-form--resume .profile-edit-dialog__field-type:not(.hidden),\n.profile__edit-form--contact-info .profile-edit-dialog__field,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type:not(.hidden) {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-xxs, 0.3125rem);\n  flex: 1 0 0;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__row {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__section fieldset > .profile-edit-dialog__field {\n  max-width: 100%;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__field > input,\n.profile__edit-form--resume .profile-edit-dialog__field > select,\n.profile__edit-form--resume .profile-edit-dialog__field > textarea,\n.profile__edit-form--resume .profile-edit-dialog__field-type > input,\n.profile__edit-form--resume .profile-edit-dialog__field-type > select,\n.profile__edit-form--resume .profile-edit-dialog__field-type > textarea,\n.profile__edit-form--contact-info .profile-edit-dialog__field > input,\n.profile__edit-form--contact-info .profile-edit-dialog__field > select,\n.profile__edit-form--contact-info .profile-edit-dialog__field > textarea,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > input,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > select,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > textarea {\n  align-self: stretch;\n}\n\n.profile-edit-dialog__field--resume-location {\n  flex: 1 0 0;\n  width: auto;\n  max-width: none;\n}\n\n.profile-edit-dialog__row--resume-dates {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__field--date-group {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog__date-pair {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  width: 100%;\n}\n\n.profile-edit-dialog__date-pair > select {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog__field--stack {\n  display: grid;\n  gap: var(--spacing-xxs);\n}\n\n.profile-edit-dialog__field--stack > small {\n  display: block;\n  width: 100%;\n  text-align: right;\n}\n\n.profile-edit-dialog__bio-field-container > small {\n  align-self: flex-end;\n  text-align: right;\n}\n\n.profile-edit-dialog__field--full {\n  max-width: 100% !important;\n  width: 100%;\n}\n\n.profile-edit-dialog__field--row-width {\n  max-width: 34rem;\n  width: 100%;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row,\n.profile-edit-dialog--heading .profile-edit-dialog__field--row-width {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {\n  padding-bottom: calc(var(--spacing-sm, 0.938rem) / 2);\n  margin-bottom: calc(var(--spacing-sm, 0.938rem) / 2);\n  border-bottom: 1px solid var(--slate-200, #E2E8F0);\n}\n\n.profile-edit-dialog--heading .profile-edit {\n  gap: calc(var(--spacing-lg, 1.25rem) / 2);\n}\n\n.profile-edit-dialog__login-message {\n  margin: 0;\n  font-size: var(--font-size-xs, 0.75rem);\n  color: var(--red-600, #E7000B);\n}\n\n.profile-edit-dialog__section + .profile-edit-dialog__login-message {\n  margin-top: var(--spacing-sm, 0.938rem);\n}\n\n.profile__edit-form--projects .profile-edit-dialog__login-message {\n  margin-top: var(--spacing-sm, 0.938rem);\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {\n  max-width: 100%;\n  width: 100%;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {\n  display: block;\n  width: 100%;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {\n  flex: 0 0 6.4375rem;\n  width: 6.4375rem;\n  min-width: 6.4375rem;\n  max-width: 6.4375rem;\n}\n\n.profile-edit-dialog__field-type--contact-point select {\n  width: auto;\n  max-width: none;\n  min-width: 6.4375rem;\n}\n\n.profile-edit-dialog__row--address-header {\n  max-width: 34rem;\n  align-items: flex-end;\n}\n\n.profile-edit-dialog__row--inline-end {\n  justify-content: flex-end;\n  max-width: 100%;\n}\n\n.profile-edit-dialog__checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  margin-left: auto;\n  cursor: pointer;\n}\n\n.profile-edit-dialog__checkbox-input {\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n  flex: 0 0 auto;\n  accent-color: var(--color-primary, #7C4DFF);\n  cursor: pointer;\n}\n\n.profile-edit-dialog__checkbox-input:focus-visible {\n  outline: var(--focus-indicator-width, 2px) solid var(--color-primary, #7C4DFF);\n  outline-offset: 2px;\n}\n\n.profile-edit-dialog__checkbox-input:disabled {\n  opacity: var(--opacity-disabled, 0.5);\n}\n\n/* The street-address row is a standalone label, so cap its width like the flex rows. */\n.profile-edit-dialog__section fieldset > .profile-edit-dialog__field {\n  max-width: 34rem;\n}\n\n.profile-edit-dialog__field-type--wide {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.profile-edit-dialog__field-type--contact-point {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n  align-self: flex-start;\n}\n\n.profile-edit-dialog__actions {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.profile-edit-dialog__actions--edge {\n  margin-left: auto;\n}\n\n.profile-edit-dialog__input-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.profile-edit-dialog__input--with-action {\n  width: 100%;\n  box-sizing: border-box;\n  padding-right: 7.5rem;\n}\n\n.profile-edit-dialog__input--with-leading-icon {\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: 2.1rem;\n}\n\n.profile-edit-dialog__search-icon {\n  position: absolute;\n  left: var(--spacing-2xs, 0.625rem);\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--gray-400, #99A1AF);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.profile-edit-dialog__search-icon svg {\n  display: block;\n  width: 0.8125rem;\n  height: 0.8125rem;\n}\n\n.profile-edit-dialog__delete-button {\n  min-height: var(--min-touch-target, 44px);\n  min-width: var(--min-touch-target, 44px);\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n#profile-modal .modal button.profile-edit-dialog__delete-button {\n  min-height: var(--min-touch-target, 44px);\n  min-width: var(--min-touch-target, 44px);\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: inherit;\n  box-shadow: none;\n}\n\n.profile-edit-dialog__delete-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.1rem;\n  height: 1.1rem;\n  fill: currentColor;\n}\n\n.profile-edit-dialog__delete-icon svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.profile-edit-dialog__delete-button:hover,\n.profile-edit-dialog__delete-button:focus-visible {\n  color: var(--color-danger, #b42318);\n}\n\n.profile-edit-dialog__image-button {\n  text-align: center;\n  font-size: var(--font-size-xxs, 0.75rem); /* 12 px */\n  font-weight: var(--font-weight-xbold, 700);\n  line-height: var(--line-height-base, 1.5); /* 150% */\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: 0.8px solid var(--gray-300, #D1D5DC);\n}\n\n.profile-edit-dialog__image-upload-button {\n  color: var(--gray-900, #101828);\n  border: 0.8px solid var(--gray-300, #D1D5DC);\n  background: var(--white, #FFF);\n  padding: 6.6px 11.075px 7px 12.8px;\n}\n\n.profile-edit-dialog__image-remove-button {\n  color: var(--red-600, #E7000B);\n  padding: 6.6px 13.037px 7px 13.8px;\n  border: 0.8px solid rgba(0, 0, 0, 0.00);\n  background: var(--gray-100, #F3F4F6);\n}\n\n#profile-modal .modal .profile-edit-dialog__image-upload-button:hover,\n#profile-modal .modal .profile-edit-dialog__image-upload-button:focus-visible,\n#profile-modal .modal .profile-edit-dialog__image-remove-button:hover,\n#profile-modal .modal .profile-edit-dialog__image-remove-button:focus-visible {\n  background: var(--gray-100, #F3F4F6) !important;\n  border-color: var(--gray-400, #99A1AF) !important;\n}\n\n/* Placeholder class for project paste action styling. */\n.profile-edit-dialog__paste-button {\n  display: flex;\n  padding: 0.25rem 0.375rem; /* 4px 6px */\n  align-items: center;\n  position: absolute;\n  background: var(--white, #fff);\n  border: 0;\n  outline: none;\n  white-space: nowrap;\n  right: var(--spacing-2xs, 0.625rem);\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  color: var(--gray-500, #6A7282);\n  font-size: 0.75rem; /* 12px */\n  font-weight: var(--font-weight-normal, 400);\n}\n\n.profile-edit-dialog__paste-button:focus,\n.profile-edit-dialog__paste-button:focus-visible {\n  outline: none;\n}\n\n/* remove the regular button styling for paste */\n#profile-modal .modal button.profile-edit-dialog__paste-button,\n#profile-modal .modal button.profile-edit-dialog__paste-button:hover,\n#profile-modal .modal button.profile-edit-dialog__paste-button:focus,\n#profile-modal .modal button.profile-edit-dialog__paste-button:focus-visible,\n#profile-modal .modal button.profile-edit-dialog__paste-button:active {\n  border: 0;\n  outline: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.profile-edit-dialog__paste-icon {\n  width: 0.694rem; /* 11.105px */\n  height: 0.813rem; /* 13.038px */\n  fill: var(--gray-500, #6A7282);\n}\n#profile-modal .modal button.profile-edit-dialog__drag-handle {\n  min-height: 1.75rem;\n  min-width: 1.75rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.profile-edit-dialog__row--drop-target {\n  outline: 1px dashed var(--gray-400, #99A1AF);\n  outline-offset: 2px;\n}\n\n#profile-modal .modal button.profile-edit-dialog__delete-button:hover,\n#profile-modal .modal button.profile-edit-dialog__delete-button:focus-visible {\n  border: 0;\n  background: transparent;\n  color: var(--color-danger, #b42318);\n}\n\n.profile-edit-dialog__field input,\n.profile-edit-dialog__field select,\n.profile-edit-dialog__field-type input,\n.profile-edit-dialog__field-type select {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: 1px solid var(--gray-400, #99A1AF);\n  background: var(--white, #FFF);\n  color: var(--gray-900, #101828);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-medium, 500);\n  padding: var(--spacing-2xs, 0.625rem);\n}\n\n.profile-edit-dialog__field input.profile-edit-dialog__input--with-leading-icon {\n  padding-left: 2.1rem;\n}\n\n/* Keep phone/email contact-point type selects compact. */\n.profile-edit-dialog__field-type--contact-point > select {\n  display: inline-block;\n  width: auto !important;\n  max-width: none !important;\n  min-width: 0 !important;\n}\n\n/* In heading edit, force both type selects to fill the same fixed wrapper width. */\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point > select {\n  display: block;\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n}\n\n/* Keep phone/email type selects compact after the generic full-width rule above. */\n.profile-edit-dialog__field-type--contact-point select {\n  width: fit-content;\n  max-width: none;\n  min-width: 6.4375rem;\n}\n\n.profile-edit-dialog__textarea {\n  color: var(--gray-900, #101828);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-md, 500);\n  line-height: var(--line-height-loose, 1.6); /* 22.4px */\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: var(--border-width-sm, 0.1rem) solid var(--gray-400, #99A1AF);\n  background: var(--white, #FFF);\n}\n\n.profile-edit-dialog__field textarea,\n.profile-edit-dialog__field-type textarea {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n}\n\n/* Dedicated hook for the social account type select in SocialEditDialog. */\n.profile-edit-dialog__social-account-select {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: 1px solid var(--gray-400, #99A1AF);\n  background: var(--white, #FFF);\n  color: var(--gray-900, #101828);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-medium, 500);\n  padding: var(--spacing-2xs, 0.625rem);\n\n\n}\n\n.profile-edit-dialog__bio-field-container textarea {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n}\n\n.profile-edit-dialog__textarea {\n  min-height: 10rem !important;\n  height: auto;\n  resize: vertical;\n}\n\n.profile-edit-dialog__field--stack small {\n  justify-self: end;\n  text-align: right;\n}\n\n@media (max-width: 640px) {\n  .profile-edit-dialog__row {\n    max-width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .profile-edit-dialog__row--equal > .profile-edit-dialog__field,\n  .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {\n    flex: 1 1 auto;\n  }\n\n  .profile-edit-dialog__field-type {\n    flex: 1 1 auto;\n  }\n\n  .profile-edit-dialog__field-type--contact-point {\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--address-header {\n    flex-direction: row;\n    align-items: flex-end;\n  }\n\n  .profile-edit-dialog__row--social {\n    margin-left: 0;\n    gap: var(--spacing-2xs, 0.625rem);\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n\n  .profile-edit-dialog__field--social-type {\n    flex: 0 0 5.5rem;\n    width: 5.5rem;\n    max-width: 5.5rem;\n  }\n\n  .profile-edit-dialog__field--social-url {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__field--resume-location {\n    flex: 1 1 100%;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--language {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .profile-edit-dialog__row--language > .profile-edit-dialog__field {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__row--resume-entry-header {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {\n    margin-left: auto;\n  }\n\n  .profile-edit-dialog__row--skill {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-2xs, 0.625rem);\n  }\n\n  .profile-edit-dialog__row--skill > .profile-edit-dialog__field {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {\n    flex: 0 0 auto;\n    margin-left: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-xs, 0.75rem);\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {\n    margin-bottom: 0;\n    flex: 0 0 auto;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n    width: 5.5rem;\n    height: 5.5rem;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {\n    display: inline-flex;\n    right: var(--spacing-xxs, 0.3125rem);\n    bottom: var(--spacing-xxs, 0.3125rem);\n    width: 1.875rem;\n    min-width: 1.875rem;\n    min-height: 1.875rem;\n  }\n\n  #profile-modal .modal button.profile-edit-dialog__image-camera-button {\n    display: inline-flex !important;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {\n    flex: 1 1 auto;\n    min-width: 0;\n    gap: var(--spacing-xxs, 0.3125rem);\n    width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {\n    font-size: var(--font-size-sm, 0.875rem);\n    line-height: var(--line-height-tight, 1.25);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {\n    font-size: 10px;\n    line-height: var(--line-height-base, 1.4);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {\n    flex-wrap: nowrap;\n    gap: var(--spacing-xs, 0.5rem);\n    width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {\n    flex: 1 1 0;\n    width: 100%;\n    padding: 0 0.75rem;\n  }\n\n  .profile-edit-dialog__row--inline-end {\n    justify-content: flex-start;\n  }\n\n  .profile-edit-dialog__actions {\n    justify-content: flex-start;\n  }\n\n  .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {\n    justify-content: flex-end;\n  }\n\n  .profile-edit-dialog__textarea {\n    min-height: 15rem !important;\n  }\n\n  .profile-edit-dialog__input-help-text {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
